// Shared text helpers for the audit coverage views.
//
// coverageKey() is the key the backend compares prompt texts on (sanitizeFocusList /
// seoAuditTracking.normalizeTextKey): whitespace collapsed, trimmed, cut to the stored
// length, case-insensitive. Every list that matches verdicts or measured rows to a
// prompt text has to use this one function, or rows silently stop lining up.
const MAX_PROMPT_LENGTH = 200

export function coverageKey(value) {
    return String(value == null ? "" : value)
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, MAX_PROMPT_LENGTH)
        .toLowerCase()
}

// platform ids as the backend stores them -> what the user sees
const PLATFORM_LABELS = {
    chatgpt: "ChatGPT",
    gemini: "Gemini",
    perplexity: "Perplexity",
    grok: "Grok",
    microsoft_copilot: "Copilot",
    google_ai_mode: "AI Mode",
    google_ai_overview: "AI Overviews",
    google: "Google"
}

export function platformLabel(platform) {
    const key = String(platform == null ? "" : platform).trim()
    return PLATFORM_LABELS[key] || key || "unknown"
}
